import { useCallback, useEffect, useState } from 'react'
import getAllSocilaMedia from '../../apis/getAllSocilaMedia'
import MediaRow from './MediaRow'

const SocialMedia = () => {
  const [loading, setLoading] = useState(true)
  const [socialMedia, setSocialMedia] = useState(true)

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const socialMediadata = await getAllSocilaMedia()
      setSocialMedia(socialMediadata)
    } catch (error) {
      console.error('Failed to fetch', error)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const updateData = async (updatedMedia) => {
    if (updatedMedia) {
      // Update the specific media item in the list
      setSocialMedia((prev) =>
        prev.map((media) =>
          media.id === updatedMedia.id ? { ...media, ...updatedMedia } : media
        )
      )
    } else {
      // Refetch the entire data
      fetchData()
    }
  }

  return (
    <div>
      {loading ? (
        <>loading</>
      ) : (
        <>
          <div className="w-full ">
            <div className="flex py-2  text-darkBlue sticky top-0 bg-lightBlue/10 z-10">
              <div className="flex-1 p-2 items-center justify-center flex">
                image
              </div>
              <div className="flex-1 p-2 items-center justify-center flex">
                name
              </div>
              <div className="flex-1 p-2 items-center justify-center flex">
                Link
              </div>
              <div className="flex-1 p-2 items-center justify-center flex">
                Actions
              </div>
            </div>
            <div className="overflow-y-auto max-h-60">
              {loading ? (
                <div>loading ... </div>
              ) : (
                socialMedia.map((media, index) => (
                  <MediaRow
                    media={media}
                    index={index}
                    updateData={updateData}
                  />
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default SocialMedia
